// extracted by mini-css-extract-plugin
export var searchHeader = "_8k-0";
export var searchHeaderDark = "_8k-1";